import ANDROID from '../../assets/stack/android-studio-64.png';
import AWS from '../../assets/stack/aws.svg';
import CIRCLE_CI from '../../assets/stack/circleci-64.png';
import DETOX from '../../assets/stack/detox-64.png';
import DOCKER from '../../assets/stack/docker.svg';
import EXPO from '../../assets/stack/expo-64.png';
import FIREBASE from '../../assets/stack/firebase-64.png';
import GRAPHQL from '../../assets/stack/graphql-64.png';
import JEST from '../../assets/stack/jest.svg';
import MAESTRO from '../../assets/stack/maestro-64.png';
import NODE_JS from '../../assets/stack/nodejs-64.png';
import RAILWAY from '../../assets/stack/railway.svg';
import REACT_NATIVE from '../../assets/stack/react-native-icon.png';
import REANIMATED from '../../assets/stack/reanimated-horse-64.png';
import SKIA from '../../assets/stack/skia-icon-64.png';
import SUPABASE from '../../assets/stack/supabase.svg';
import TYPESCRIPT from '../../assets/stack/typescript.svg';
import XCODE from '../../assets/stack/xcode-64.png';

export const STACK_ITEMS = [
  {
    title: 'React Native',
    description: 'Cross-platform apps.',
    icon: REACT_NATIVE,
  },
  {
    title: 'Expo',
    description: 'App framework.',
    icon: EXPO,
  },
  {
    title: 'TypeScript',
    description: 'JavaScript With Syntax For Types',
    icon: TYPESCRIPT,
  },
  {
    title: 'Xcode',
    description: 'iOS development.',
    icon: XCODE,
  },
  {
    title: 'Android Studio',
    description: 'Android development.',
    icon: ANDROID,
  },
  {
    title: 'Skia',
    description: '2D graphics.',
    icon: SKIA,
  },

  {
    title: 'Reanimated',
    description: 'Animations.',
    icon: REANIMATED,
  },
  {
    title: 'Supabase',
    description: 'Backend platform.',
    icon: SUPABASE,
  },
  {
    title: 'Firebase',
    description: 'Backend platform.',
    icon: FIREBASE,
  },
  {
    title: 'AWS',
    description: 'Cloud provider.',
    icon: AWS,
  },
  { title: 'Railway', description: 'Cloud provider.', icon: RAILWAY },
  {
    title: 'Node.js',
    description: 'Backend runtime.',
    icon: NODE_JS,
  },
  {
    title: 'GraphQL',
    description: 'API query language.',
    icon: GRAPHQL,
  },
  {
    title: 'CircleCI',
    description: 'CI/CD platform.',
    icon: CIRCLE_CI,
  },
  {
    title: 'Docker',
    description: 'Containerization software platform.',
    icon: DOCKER,
  },
  {
    title: 'Detox',
    description: 'E2E mobile testing.',
    icon: DETOX,
  },
  {
    title: 'Jest',
    description: 'JS testing framework.',
    icon: JEST,
  },
  {
    title: 'Maestro',
    description: 'UI testing.',
    icon: MAESTRO,
  },
] as const;
